<template>
  <div class="d-flex align-items-center text-dark border-bottom py-2 cursor-pointer" :class="[isSelected ? 'spnod-message__selected' : 'spnod-message__item']" @click="$emit('changeMessage', { index, message })">
    <div class="spnod-message-summary__icon fi px-2" :class="[flatIcon, isSelected ? 'text-white' : '']">
      <img v-if="avatar" :src="avatar" width="32" height="32" class="rounded-circle"/>
    </div>
    <div :class="[message.totalMessagesUnreadByMe > 0 ? 'spnod-text--bold' : '', isSelected ? 'text-white' : '']" class="d-block text-truncate">
      <div class="pb-1">
        <span v-for="(participant, participantIndex) in message.participants" :key="participantIndex" class="spnod-message-summary__participant" :class="{ 'spnod-message__participant--inactive': participant.inActive }">
          {{ participant.name}}{{participantIndex != message.participants.length - 1 ? ', ' : '' }}
        </span>
      </div>
      <div class="d-block text-truncate">{{ message.lastMessage }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Message',
  props: ['message', 'index', 'active'],
  computed: {
    ...mapGetters(['getMessageParticipants', 'getMyInfo']),
    isSelected() { return this.active === this.index },
    avatar() {
      return false
      // if (!this.message || !this.message.client) return
      // const participant = this.getMessageParticipants.find(p => p._id && p._id === this.message.client._id)
      // if (participant.profilePic) return participant.profilePic
    },
    flatIcon() {
      return !!this.avatar || `flaticon-user-${this.index + 2}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Messaging/Message.vue?feb436ce